'use strict';

/* globals define, ajaxify, $, socket, app, utils, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/course/course-editor', [
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-invite-to-group/public/vendor/multiselect/jquery.multi-select.js',
	'translator',
	'benchpress',
	'courseCreator',
	'coverPhoto',
	'pictureCropper',
	'slugify',
	'bootbox',
], function (vue, multiselect, translator, Benchpress, courseCreator, coverPhoto, pictureCropper, slugify, bootbox) {
	var	CourseEditor = {};

	var uploadingData = {
		onStart: function () {},
		onEnd: function () {},
		onProgress: function () {},
	};

	CourseEditor.init = function () {
		courseCreator.init(ajaxify.data.course, ajaxify.data.translations);

		addActions();
		addMultiSelect();
	};

	function addMultiSelect() {
		$('#course-groups').multiSelect({
			selectableHeader: 'All groups',
			selectionHeader: 'Course groups',
		});
	}

	function addActions() {
		var actions = {
			'add-cover': addCover,
			'remove-cover': removeCover,
			'add-trainer-image': addTrainerImage,
			'remove-trainer-image': removeTrainerImage,
			update: updateCourse,
			publish: publishCourse,
			hide: hideCourse,
			delete: deleteCourse,
		};

		for (var key in actions) {
			if (actions.hasOwnProperty(key)) {
				$('[data-action="' + key + '"]').click(actions[key]);
			}
		}

		addUploadAction();
	}

	function updateCourse() {
		save('plugins.courses.updateCourse');
	}

	function publishCourse() {
		save('plugins.courses.publishCourse');
	}

	function hideCourse() {
		$('#isVisible').prop('checked', false);

		updateCourse();
	}

	function save(saveUrl) {
		applyFormValues();

		var data = $.extend({}, ajaxify.data.course, { chapters: getParsedChapters(), trainers: getParsedTrainers(), files: getParsedFiles() });

		socket.emit(saveUrl, data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'course_edited',
				message: '[[courses:course-edited]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('groups/' + ajaxify.data.group.slug + '/course/' + ajaxify.data.course.courseId + '/' + slugify(data.title));
		});
	}

	function getParsedChapters() {
		var chapters = [];

		for (var chapterIndex = 0; chapterIndex < ajaxify.data.course.chapters.length; chapterIndex++) {
			var chapter = ajaxify.data.course.chapters[chapterIndex];

			chapters.push({
				title: chapter.title,
				description: chapter.description,
				video: chapter.video,
				videoThumbnail: chapter.videoThumbnail,
				footerImage: chapter.footerImage,
				footerText: chapter.footerText,
			});
		}

		return chapters;
	}

	function getParsedTrainers() {
		var trainers = [];

		for (var trainerIndex = 0; trainerIndex < ajaxify.data.course.trainers.length; trainerIndex++) {
			var trainer = ajaxify.data.course.trainers[trainerIndex];

			trainers.push({
				name: trainer.name,
				image: trainer.image,
				video: trainer.video,
				videoThumbnail: trainer.videoThumbnail,
				description: trainer.description,
			});
		}

		return trainers;
	}

	function getParsedFiles() {
		var files = [];

		for (var fileIndex = 0; fileIndex < ajaxify.data.course.files.length; fileIndex++) {
			var file = ajaxify.data.course.files[fileIndex];

			files.push({
				name: file.name,
				url: file.url,
			});
		}

		return files;
	}

	function applyFormValues() {
		ajaxify.data.course.description = $('#description').val();
		ajaxify.data.course.title = $('#title').val();
		ajaxify.data.course.trainerName = $('#trainerName').val();
		ajaxify.data.course.isVisible = $('#isVisible').is(':checked');
		ajaxify.data.course.groups = $('#course-groups').val();
	}

	function deleteCourse() {
		bootbox.confirm('Do you want to delete course?', function (confirm) {
			if (!confirm) {
				return;
			}

			socket.emit('plugins.courses.removeCourse', {
				courseId: ajaxify.data.course.courseId,
				group: ajaxify.data.group.name,
			}, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'course_removed',
					message: '[[courses:course-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('groups/' + ajaxify.data.group.slug + '/courses');
			});
		});
	}

	function addCover() {
		addImage(function (imageUrl) {
			saveFilePrivileges(imageUrl);

			ajaxify.data.course.cover = imageUrl;

			$('#contentCover img').attr('src', imageUrl);
			$('#contentCover').show();
			$('[data-action="add-cover"]').hide();
		});
	}

	function removeCover() {
		$('#contentCover img').attr('src', '');
		$('#contentCover').hide();
		$('[data-action="add-cover"]').show();

		ajaxify.data.course.cover = null;
	}

	function addTrainerImage() {
		addImage(function (imageUrl) {
			saveFilePrivileges(imageUrl);

			ajaxify.data.course.trainerImage = imageUrl;

			$('#trainerImage img').attr('src', imageUrl);
			$('#trainerImage').show();
			$('[data-action="add-trainer-image"]').hide();
		});
	}

	function addImage(callback) {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.courses.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
		}, callback);
	}

	function removeTrainerImage() {
		$('#trainerImage img').attr('src', '');
		$('#trainerImage').hide();
		$('[data-action="add-trainer-image"]').show();

		ajaxify.data.course.trainerImage = null;
	}

	function saveFilePrivileges(fileName) {
		socket.emit('plugins.filePermissionSockets.saveFileFromGroupPrivileges', { fileName: fileName, groupName: ajaxify.data.group.name }, function (err) {
			if (err) {
				return app.alertError(err.message);
			}
		});
	}

	function addUploadAction() {
		$('#contentFileForm #files').on('change', function (e) {
			var files = (e.target || {}).files || ($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);

			if (files) {
				uploadFile({
					files: files,
					route: '/api/post/upload',
					filename: $(this).val().replace(/^.*[\\/]/, ''),
				});
			}
		});
	}

	function uploadFile(params) {
		var filesForm = $('#contentFileForm');

		filesForm.attr('action', config.relative_path + params.route);

		filesForm.off('submit').submit(function () {
			uploadingData.onStart();

			$(this).ajaxSubmit({
				headers: {
					'x-csrf-token': config.csrf_token,
				},
				resetForm: true,
				clearForm: true,
				formData: params.formData,
				data: { },

				error: function (xhr) {
					app.alertError(xhr.responseJSON.error);
				},

				uploadProgress: function (event, position, total, percent) {
					uploadingData.onProgress(percent);
				},

				success: function (uploads) {
					uploadingData.onEnd(uploads.response.images[0] || {});
				},

				complete: function () {

				},
			});

			return false;
		});

		filesForm.submit();
	}

	return CourseEditor;
});
